const routes = {
  createBay: 'bay',
  getBays: 'bay',
  getBayById: 'bay/',
  updateBay: 'bay/',
  deleteBay: 'bay/',
};

export default routes